import { FieldTypes } from '@nts/std/types';
import { FieldMetaData } from './field-meta-data';
import { SpacerMetaDataInterface } from '@nts/std/interfaces';

export class SpacerMetaData extends FieldMetaData implements SpacerMetaDataInterface {

  override getFieldType(): FieldTypes {
    return FieldTypes.Spacer;
  }
}
